import React, { FunctionComponent } from "react";
import { Switch, Route, withRouter, RouteComponentProps } from "react-router";
import { CurrencyMaster } from "./CurrencyMaster";

const CurrencyManagementRoutes: FunctionComponent<RouteComponentProps> = ({
  match: { url },
}) => (
  <Switch>
    <Route exact path={`${url}/`} render={() => <CurrencyMaster />} />
  </Switch>
);

export const CurrencyManagement = withRouter(CurrencyManagementRoutes);
